import { render, staticRenderFns } from "./Staging.vue?vue&type=template&id=5cb4ff48"
import script from "./Staging.vue?vue&type=script&lang=js"
export * from "./Staging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports